import React, { useState } from 'react'
import { Button, Form, Input, message, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { Option } from 'antd/es/mentions'
import { getRequestAuth, patchRequestForm, postRequest, postRequestForm } from '../../../request/request'
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors'

interface Props {
  isModalOpen: boolean
  setIsModalOpen: (e: boolean) => void
  clearForm: boolean
  regionDataLoading: boolean
  setReload: any
  editData: any
  regionData: any
  typeModal?: string | undefined | null
}

const AddingHuntingGrounds: React.FC<Props> = ({
  isModalOpen,
  setIsModalOpen,
  typeModal,
  editData,
  regionData,
  setReload,
  regionDataLoading,
}) => {
  const { t } = useTranslation()
  const [add] = Form.useForm()
  const [loading, setLoading] = useState<boolean>(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [inputError, setInputError] = useState(false)
  let timeOut: any

  const modalTitle = () => {
    switch (typeModal) {
      case 'add':
        return t('profile.p5')
      case 'edit':
        return `${t('h156')}: ${editData?.trophy_type?.name || '-'}`
      case 'view':
        return `${t('h157')}: ${editData?.trophy_type?.name || '-'}`
      default:
        return `${t('h156')}: ${editData?.trophy_type?.name || '-'}`
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    timeOut = setTimeout(() => {
      add.resetFields()
      setValidateErrors({})
      setLoading(false)
    }, 200)
  }

  const handleFinish = async (values: any) => {
    if (typeModal === 'add') {
      postRequest('/trophy_book/hunting_farm', values)
        .then(() => {
          setLoading(false)
          message.success(t('h80'))
          setReload((prev: boolean) => !prev)
          handleCancel()
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data, setValidateErrors)
        })

      // if (typeModal === 'edit') {
      //   const formData = new FormData()
      //
      //   if (addFileList?.length > 0 && addFile.length > 0) {
      //     const date = convertDate(values.date)
      //     const body = { ...values, date, hunter: editData.hunter }
      //
      //     Object.keys(body).forEach((key) => {
      //       formData.append(key, body[key])
      //     })
      //
      //     if (addFile?.length > 0 && addFile[0]?.originFileObj) {
      //       if (Object.prototype.hasOwnProperty.call(addFile[0], 'type')) {
      //         formData.append('certificate', addFile[0].originFileObj)
      //       }
      //     }
      //
      //     setLoading(true)
      //     patchRequestForm(`/trophy_book/application/${editData.id}`, formData)
      //       .then(() => {
      //         handleCancel()
      //         setReload((prev: boolean) => !prev)
      //       })
      //       .catch((err) => {
      //         setLoading(false)
      //         validatorServerErrors(err.data, setValidateErrors)
      //       })
      //   }
      // }
    }
  }

  return (
    <Modal title={modalTitle()} width={900} open={isModalOpen} onCancel={handleCancel} className="ptb-0" footer={false}>
      <Form
        name="add"
        form={add}
        autoComplete="off"
        onFinish={handleFinish}
        layout="vertical"
        style={{
          padding: '24px 32px',
        }}
      >
        <Form.Item
          name="title"
          label={t('h153')}
          validateStatus={validateErrors?.title ? 'error' : ''}
          help={validateErrors?.title}
          rules={[{ required: true, message: t('h108') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="region"
          label={t('h154')}
          rules={[{ required: true, message: t('h155') }]}
          validateStatus={validateErrors?.region ? 'error' : ''}
          help={validateErrors?.region}
        >
          <Select placeholder={t('h155')} allowClear loading={regionDataLoading}>
            {regionData?.map(({ id, region_name }: { id: number; region_name: string }) => (
              <React.Fragment key={id}>
                <Option value={String(id)}>{region_name}</Option>
              </React.Fragment>
            ))}
          </Select>
        </Form.Item>

        <div className="text-center">
          <Button
            key="submit"
            htmlType="submit"
            type="primary"
            loading={loading}
            style={{ backgroundColor: '#4A552E', borderColor: '#4A552E', boxShadow: '0 1px 4px 1px #E8EDE9' }}
          >
            {typeModal === 'add' ? t('profile.p5') : t('h60')}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

export default AddingHuntingGrounds
